import { render } from "./UpdateVideo.vue?vue&type=template&id=276289fe&scoped=true"
import script from "./UpdateVideo.vue?vue&type=script&lang=js"
export * from "./UpdateVideo.vue?vue&type=script&lang=js"

import "./UpdateVideo.vue?vue&type=style&index=0&id=276289fe&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276289fe"]])

export default __exports__